// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rfV_","label":"styles_label__1JsXW"};